// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const Play: React.FC<{ width?: number; height?: number }> = ({ width = 90, height = 90 }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 12 14">
            <path
                fill="currentColor"
                d="M1.5,0 C0.6875,0 0,0.6875 0,1.5 L0,12.5 C0,13.34375 0.6875,14 1.5,14 L3.5,14 C4.34375,14 5,13.34375 5,12.5 L5,1.5 C5,0.6875 4.34375,0 3.5,0 L1.5,0 Z M8.5,0 C7.6875,0 7,0.6875 7,1.5 L7,12.5 C7,13.34375 7.6875,14 8.5,14 L10.5,14 C11.34375,14 12,13.34375 12,12.5 L12,1.5 C12,0.6875 11.34375,0 10.5,0 L8.5,0 Z"
            />
        </svg>
    );
};

export default React.memo(Play);
